<template>
	<div class="home">
		<div class="banner">
			<img class="logo" src="../../static/img/logo.png" />
			<h5><span>|</span> 会员管理系统</h5>
			<div class="user_msg">
				<img src="../../static/img/icon1.png" />
				<div>
					<strong>{{name1}}</strong>
					<p>会员编号：<span>{{bh}}</span></p>
				</div>
				<span class="out" @click="out">退出</span>
			</div>
		</div>
		<div class="center">
			<div class="shade" v-show="tc">
				<div class="tc">
					<p class="tc_tit">提示 <span class="closed" @click="cancel"></span></p>
					<p>您是否要退出，如果退出，数据将会丢失</p>
					<div>
						<span class="no" @click="cancel">取消</span>
						<span class="sure" @click="out1">确定</span>
					</div>
						
				</div>
			</div>
			
			<div class="con_con">
				<div class="con_con_top">干部任免审批表 </div>
				<div class="con_con_form">
					<p class="con_con_form_tit">个人信息</p>
					
					<div class="con_con_item">
						<span class="type1">姓名</span>
						<input style="width: 120px;" type="text" class="form_name" v-model="name" />
						<span style="width: 61px;">性别</span>
						<el-radio-group v-model="sex">
							<el-radio label="男"></el-radio>
							<el-radio label="女"></el-radio>
						</el-radio-group>
						<span style=" width: 100px;">出生日期</span>
						<el-date-picker v-model="birthdate" type="date" @change='get_time' style="width: 151px;"></el-date-picker>
						<span style=" width: 61px;">民族</span>
						<input style="width: 161px;" type="text" v-model="people" />
					</div>
					
					<div class="con_con_item">
						<span class="type1">籍贯</span>
						<input style="width: 340px;" type="text" v-model="native_place" />
						<span class="type1">出生地</span>
						<input style="width: 340px;" type="text" v-model="birthplace" />
					</div>
					
					<div class="con_con_item">
						<span class="type1">入党时间</span>
						<el-date-picker v-model="party_time" type="date" style="width: 151px;"></el-date-picker>
						<span class="type1" style="margin-left: 45px;width: 100px;">参加工作时间</span>
						<el-date-picker v-model="attack_time" type="date" style="width: 151px;"></el-date-picker>
						<span class="type1" style="margin-left: 45px;">健康状况</span>
						<input style="width: 161px;" type="text" v-model="health_condition" />
					</div>
					
					<div class="con_con_item">
						<span class="type1">专业技术职务</span>
						<input style="width: 330px;height: 40px;" type="text" v-model="professional_title" />
						<span class="flex" style="display: inline-block;height: 40px;width: 100px;vertical-align: middle;">熟悉专业<br>有何专长</span>
						<input style="width: 340px;" type="text" v-model="speciality" />
					</div>
					
					<div class="flex" style="width: 100%;height: auto;margin-bottom: 22px;overflow: hidden;">
						<p class="fl clearfix" style="width:40px;height: 100%;">学历<br>学位</p>
						<div class="fl clearfix" style="border: 1px solid #C0C4CC;width: 840px;padding-top: 30px;">
							<div class="con_con_item">
								<span class="flex" style="display: inline-block;height: 40px;width: 100px;vertical-align: middle;">全日制<br>教育</span>
								<input style="width: 300px;" type="text" v-model="full_time_education" />
								<span class="flex" style="display: inline-block;height: 40px;width: 100px;vertical-align: middle;">毕业院校<br>系及专业</span>
								<input style="width: 300px;" type="text" v-model="colleges_and_majors1" />
							</div>
							<div class="con_con_item">
								<span class="flex" style="display: inline-block;height: 40px;width: 100px;vertical-align: middle;">在职<br>教育</span>
								<input style="width: 300px;" type="text" v-model="part_time_education" />
								<span class="flex" style="display: inline-block;height: 40px;width: 100px;vertical-align: middle;">毕业院校<br>系及专业</span>
								<input style="width: 300px;" type="text" v-model="colleges_and_majors2" />
							</div>
						</div>						
					</div>
					
					<div class="con_con_item">
						<span class="type1">现任职务</span>
						<input style="width: 210px;" type="text" v-model="present_title" />
						<span style="width: 65px;">拟任职务</span>
						<input style="width:210px;" type="text" v-model="designated_title" />
						<span style="width: 65px;">拟免职务</span>
						<input style="width: 210px;" type="text" v-model="remove_title" />
					</div>
										
					<div class="con_con_form_center">
						<p> 简 历 </p>
						<div class="con_con_table">
							<ul>
								<li>起止时间</li>
								<li>工作单位</li>
								<li>职务</li>
							</ul>
							<textarea rows="9" cols="109" v-model="curriculum_vitae" :placeholder="defaultContent"></textarea>
						</div>
					</div>

					<div class="con_con_item1">
						<p class="flex fl clearfix">奖惩情况</p>
						<textarea class="fr clearfix" rows="9" cols="109" v-model="rewards_and_penalties"></textarea>
					</div>
					
					<div class="con_con_item1">
						<p class="flex fl clearfix">年度考核结果</p>
						<textarea class="fr clearfix" rows="9" cols="109" v-model="evaluation_result"></textarea>
					</div>
					
					<div class="con_con_item1">
						<p class="flex fl clearfix">任免理由</p>
						<textarea class="fr clearfix" rows="9" cols="109" v-model="reason"></textarea>
					</div>
					
					<div class="flex" style="align-items: center;justify-content: space-between;">
						<p class="fl clearfix flex" style="width: 40px;margin-left: 40px;">家庭主要成员及重要社会关系</p>
						<div class="fr clearfix" style="width:790px;">
							<div class="flex" style="width: 100%;border:1px solid #CECECE;margin-bottom: 20px;box-sizing: border-box;">
								<span class="fl clearfix w90" style="text-align: center;">称谓</span >
								<span class="fl clearfix w90" style="text-align: center;">姓名</span>
								<span class="fl clearfix w90" style="text-align: center;">年龄</span>
								<span class="fl clearfix w90" style="text-align: center;">政治<br>面貌</span>
								<span class="fl clearfix" style="width:430px;text-align: center;">工作单位及职务</span>
							</div>
							<div class="flex" style="width: 100%;margin-bottom: 30px;">
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_relation1"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_name1"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_age1"/>
								<input class="h40 fl clearfix input w90" v-model="politics_status1"/>
								<input class="h40 fl clearfix input " style="width: 430px;" v-model="company_name1"/>
							</div>
							<div class="flex" style="width: 100%;margin-bottom: 30px;">
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_relation2"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_name2"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_age2"/>
								<input class="h40 fl clearfix input w90" v-model="politics_status2"/>
								<input class="h40 fl clearfix input " style="width: 430px;" v-model="company_name2"/>
							</div>
							<div class="flex" style="width: 100%;margin-bottom: 30px;">
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_relation3"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_name3"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_age3"/>
								<input class="h40 fl clearfix input w90" v-model="politics_status3"/>
								<input class="h40 fl clearfix input " style="width: 430px;" v-model="company_name3"/>
							</div>
							<div class="flex" style="width: 100%;margin-bottom: 30px;">
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_relation4"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_name4"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_age4"/>
								<input class="h40 fl clearfix input w90" v-model="politics_status4"/>
								<input class="h40 fl clearfix input " style="width: 430px;" v-model="company_name4"/>
							</div>
							<div class="flex" style="width: 100%;margin-bottom: 30px;">
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_relation5"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_name5"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_age5"/>
								<input class="h40 fl clearfix input w90" v-model="politics_status5"/>
								<input class="h40 fl clearfix input " style="width: 430px;" v-model="company_name5"/>
							</div>
							<div class="flex" style="width: 100%;margin-bottom: 30px;">
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_relation6"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_name6"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_age6"/>
								<input class="h40 fl clearfix input w90" v-model="politics_status6"/>
								<input class="h40 fl clearfix input " style="width: 430px;" v-model="company_name6"/>
							</div>
							<div class="flex" style="width: 100%;margin-bottom: 30px;">
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_relation7"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_name7"/>
								<input class="h40 fl clearfix input w90" v-model="kinsfolk_age7"/>
								<input class="h40 fl clearfix input w90" v-model="politics_status7"/>
								<input class="h40 fl clearfix input " style="width: 430px;" v-model="company_name7"/>
							</div>
						</div>
						
					</div>
					
					<div class="flex" style="margin-bottom: 30px;align-items: center;justify-content: space-between;">
						<p class="flex" style="margin-left: 40px;">呈报<br>单位</p>
						<textarea  style="border-radius: 5px;" rows="3" cols="110" v-model="reporting_unit"></textarea>
					</div>
					
					<div class="con_con_item">
						<span class="type1" style="padding-right: 10px;box-sizing:border-box;margin-right: 5px;">填表人</span>
						<input style="width: 340px;" type="text" v-model="preparer" />
					</div>

					<button class="btn" @click="summit" v-if="btn">提交</button>
					<button class="btn" @click="summit1" v-else>提交</button>
				</div>
			</div>
		</div>
		<bottom></bottom>
	</div>
</template>

<script>
	import { Loading } from 'element-ui';
	import area from '../../static/js/area.js';
	import Qs from 'qs';
	import bottom from './Bottom'
	export default {
		components: {
			bottom
		},
		data() {
			return {
				id:'',
				defaultContent:'请按时间顺序由近到远填写，例如：2015-2019，A企业，总经理；\n\n2013-2015，B企业，副总经理；\n\n2007-2013，C企业，副总经理；',
				tc:false,
				name1: '',
				bh: '',
				btn:true,
				
				name: '',
				sex: '',
				birthdate: '',
				old:'',
				people:'',
				native_place: '',
				birthplace: '',
				party_time: '',
				attack_time: '',
				health_condition: '',
				professional_title: '',
				speciality:'',
				full_time_education: '',
				colleges_and_majors1: '',
				part_time_education: '',
				colleges_and_majors2: '',
				present_title: '',
				designated_title:'',
				remove_title: '',
				curriculum_vitae: '',
				rewards_and_penalties: '',
				evaluation_result:'',
				reason: '',
				kinsfolk_relation1: '',
				kinsfolk_relation2: '',
				kinsfolk_relation3: '',
				kinsfolk_relation4: '',
				kinsfolk_relation5: '',
				kinsfolk_relation6: '',
				kinsfolk_relation7: '',
				kinsfolk_name1:'',
				kinsfolk_name2:'',
				kinsfolk_name3:'',
				kinsfolk_name4:'',
				kinsfolk_name5:'',
				kinsfolk_name6:'',
				kinsfolk_name7:'',
				kinsfolk_age1:'',
				kinsfolk_age2:'',
				kinsfolk_age3:'',
				kinsfolk_age4:'',
				kinsfolk_age5:'',
				kinsfolk_age6:'',
				kinsfolk_age7:'',
				politics_status1:'',
				politics_status2:'',
				politics_status3:'',
				politics_status4:'',
				politics_status5:'',
				politics_status6:'',
				politics_status7:'',
				company_name1:'',
				company_name2:'',
				company_name3:'',
				company_name4:'',
				company_name5:'',
				company_name6:'',
				company_name7:'',
				reporting_unit:'',
				preparer:'',
			};
		},

		created() {},
		mounted() {
			if(sessionStorage.getItem('name')) {
				this.name1 = sessionStorage.getItem('name');
			};
			if(sessionStorage.getItem('bh')) {
				this.bh = sessionStorage.getItem('bh');
			};	
			if(sessionStorage.getItem('Token')) {
				var token = sessionStorage.getItem('Token');
			};
			if(sessionStorage.getItem('renMian_id')) {
				var renMian_id = sessionStorage.getItem('renMian_id');
				this.id = sessionStorage.getItem('renMian_id');
			};
			var data = {
				'id': renMian_id,
				'access-token': token
			};
			this.$axios({
				method: 'post',
				url: 'director/appointremovalinfo',
				data: Qs.stringify(data)
			}).then(response => {
				if(response.data.state == 2 && response.data.data !='') {
					this.btn = false;
					console.log(response.data);
					this.name = response.data.data.name;
					this.sex = response.data.data.sex;
					this.birthdate = response.data.data.birthdate;
					this.old = response.data.data.birthdate+','+response.data.data.age;
					this.people = response.data.data.people;
					this.native_place = response.data.data.native_place;
					this.birthplace = response.data.data.birthplace;
					this.party_time = response.data.data.party_time;
					this.attack_time = response.data.data.attack_time;
					this.health_condition = response.data.data.health_condition;
					this.professional_title = response.data.data.professional_title;
					this.speciality = response.data.data.speciality;
					this.full_time_education = response.data.data.full_time_education;
					this.colleges_and_majors1 = response.data.data.colleges_and_majors1;
					this.part_time_education = response.data.data.part_time_education;
					this.colleges_and_majors2 = response.data.data.colleges_and_majors2;
					this.present_title = response.data.data.present_title;
					this.designated_title = response.data.data.designated_title;
					this.remove_title = response.data.data.remove_title;
					this.curriculum_vitae = response.data.data.curriculum_vitae;
					this.rewards_and_penalties = response.data.data.rewards_and_penalties;
					this.evaluation_result = response.data.data.evaluation_result;
					this.reason = response.data.data.reason;
					this.kinsfolk_relation1 = response.data.data.kinsfolk_relation1;
					this.kinsfolk_relation2 = response.data.data.kinsfolk_relation2;
					this.kinsfolk_relation3 = response.data.data.kinsfolk_relation3;
					this.kinsfolk_relation4 = response.data.data.kinsfolk_relation4;
					this.kinsfolk_relation5 = response.data.data.kinsfolk_relation5;
					this.kinsfolk_relation6 = response.data.data.kinsfolk_relation6;
					this.kinsfolk_relation7 = response.data.data.kinsfolk_relation7;
					this.kinsfolk_name1 = response.data.data.kinsfolk_name1;
					this.kinsfolk_name2 = response.data.data.kinsfolk_name2;
					this.kinsfolk_name3 = response.data.data.kinsfolk_name3;
					this.kinsfolk_name4 = response.data.data.kinsfolk_name4;
					this.kinsfolk_name5 = response.data.data.kinsfolk_name5;
					this.kinsfolk_name6 = response.data.data.kinsfolk_name6;
					this.kinsfolk_name7 = response.data.data.kinsfolk_name7;
					this.kinsfolk_age1 = response.data.data.kinsfolk_age1;
					this.kinsfolk_age2 = response.data.data.kinsfolk_age2;
					this.kinsfolk_age3 = response.data.data.kinsfolk_age3;
					this.kinsfolk_age4 = response.data.data.kinsfolk_age4;
					this.kinsfolk_age5 = response.data.data.kinsfolk_age5;
					this.kinsfolk_age6 = response.data.data.kinsfolk_age6;
					this.kinsfolk_age7 = response.data.data.kinsfolk_age7;
					this.politics_status1 = response.data.data.politics_status1;
					this.politics_status2 = response.data.data.politics_status2;
					this.politics_status3 = response.data.data.politics_status3;
					this.politics_status4 = response.data.data.politics_status4;
					this.politics_status5 = response.data.data.politics_status5;
					this.politics_status6 = response.data.data.politics_status6;
					this.politics_status7 = response.data.data.politics_status7;
					this.company_name1 = response.data.data.company_name1;
					this.company_name2 = response.data.data.company_name2;
					this.company_name3 = response.data.data.company_name3;
					this.company_name4 = response.data.data.company_name4;
					this.company_name5 = response.data.data.company_name5;
					this.company_name6 = response.data.data.company_name6;
					this.company_name7 = response.data.data.company_name7;
					this.reporting_unit = response.data.data.reporting_unit;
					this.preparer = response.data.data.preparer;
				}

			});
		},
		methods: {
			cancel(){
	    		this.tc=false;
	    	},
	    	out(){
	    		this.tc=true;
	    	},
	    	out1(){
	    		if(sessionStorage.getItem('Token')){
			        var token =  sessionStorage.getItem('Token');
			    };
			    var data1={
					'access-token':token
				};
			    this.$axios({
					method: 'post',
					url: 'user/logout',
					data: Qs.stringify(data1)
				}).then(response => {
					console.log(response.data);
					if(response.data.state==1){
						localStorage.clear();
						sessionStorage.clear();
						this.$router.push('/login');
					}else{
						this.$toast(response.data.msg);
					}
				})
	    	},
			get_time(){
				if(this.birthdate){
					var str=this.birthdate.toISOString().slice(0, 10);
					var r  = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);     
			        if(r==null)return   false;     
			        var d= new Date(r[1],r[3]-1,r[4]);     
			        if(d.getFullYear()==r[1]&&(d.getMonth()+1)==r[3]&&d.getDate()==r[4]){   
			            var Y =new Date().getFullYear();   
			            this.old =str+','+(Y-r[1]); 
			            console.log(this.old);
			        }     
				}				
			},
			summit() {
				if(!this.name) {
					this.$toast('请输入姓名');
					return false;
				};
				if(!this.sex) {
					this.$toast('请选择性别')
					return false;
				};
				if(!this.birthdate) {
					this.$toast('请选择出生日期');
					return false;
				};
				if(!this.people) {
					this.$toast('请输入民族')
					return false;
				};
				if(!this.native_place) {
					this.$toast('请输入籍贯')
					return false;
				};
				if(!this.birthplace) {
					this.$toast('请输入出生地')
					return false;
				};
				if(!this.party_time) {
					this.$toast('请选择入党时间')
					return false;
				};
				if(!this.attack_time) {
					this.$toast('请选择参加工作时间')
					return false;
				};
				if(!this.health_condition) {
					this.$toast('请输入健康状况')
					return false;
				};
				if(!this.professional_title) {
					this.$toast('请输入专业技术职务')
					return false;
				};
				if(!this.speciality) {
					this.$toast('请输入专长')
					return false;
				};
				if(!this.full_time_education && !this.part_time_education) {
					this.$toast('请选填学历')
					return false;
				};
				
				if(this.full_time_education) {
					if(!this.colleges_and_majors1){
						this.$toast('请输入毕业院校及专业')
						return false;
					}					
				};
				
				if(this.part_time_education) {
					if(!this.colleges_and_majors2){
						this.$toast('请输入毕业院校及专业')
						return false;
					}					
				};
				
				if(!this.present_title) {
					this.$toast('请输入现任职务')
					return false;
				};
				if(!this.designated_title) {
					this.$toast('请输入拟任职务')
					return false;
				};
				if(!this.remove_title) {
					this.$toast('请输入拟免职务')
					return false;
				};
				if(!this.curriculum_vitae) {
					this.$toast('请输入简历')
					return false;
				};
				if(!this.rewards_and_penalties) {
					this.$toast('请输入奖惩情况')
					return false;
				};
				if(!this.evaluation_result) {
					this.$toast('请输入年度考核结果')
					return false;
				};
				if(!this.reason) {
					this.$toast('请输入任免理由')
					return false;
				};
				if(!this.kinsfolk_relation1) {
					this.$toast('请输入亲属及关系称谓')
					return false;
				};
				if(!this.kinsfolk_name1) {
					this.$toast('请输入亲属及关系姓名')
					return false;
				};
				if(!this.kinsfolk_age1) {
					this.$toast('请输入亲属及关系年龄')
					return false;
				};
												
				if(!this.politics_status1) {
					this.$toast('请输入亲属及关系政治面貌')
					return false;
				};
				
				if(!this.company_name1) {
					this.$toast('请输入亲属及关系工作单位及职务')
					return false;
				};
				
				if(!this.reporting_unit) {
					this.$toast('请输入呈报单位');
					return false;
				};
				if(!this.preparer) {
					this.$toast('请输入填表人');
					return false;
				};
				Loading.service();							
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data ={
					'access-token':token,
					'director_type':3,
					'name':this.name,
					'sex':this.sex,
					'birthdate':this.old,
					'people':this.people,
					'native_place':this.native_place,
					'birthplace':this.birthplace,
					'party_time':this.party_time.toISOString().slice(0, 10),
					'attack_time':this.attack_time.toISOString().slice(0, 10),
					'health_condition':this.health_condition,
					'professional_title':this.professional_title,
					'speciality':this.speciality,
					'full_time_education':this.full_time_education,
					'colleges_and_majors1':this.colleges_and_majors1,
					'part_time_education':this.part_time_education,
					'colleges_and_majors2':this.colleges_and_majors2,
					'present_title':this.present_title,
					'designated_title':this.designated_title,
					'remove_title':this.remove_title,
					'curriculum_vitae':this.curriculum_vitae,
					'rewards_and_penalties':this.rewards_and_penalties,
					'evaluation_result':this.evaluation_result,
					'reason':this.reason,					
					'kinsfolk_relation1':this.kinsfolk_relation1,
					'kinsfolk_relation2':this.kinsfolk_relation2,
					'kinsfolk_relation3':this.kinsfolk_relation3,
					'kinsfolk_relation4':this.kinsfolk_relation4,
					'kinsfolk_relation5':this.kinsfolk_relation5,
					'kinsfolk_relation6':this.kinsfolk_relation6,
					'kinsfolk_relation7':this.kinsfolk_relation7,					
					'kinsfolk_name1':this.kinsfolk_name1,
					'kinsfolk_name2':this.kinsfolk_name2,
					'kinsfolk_name3':this.kinsfolk_name3,
					'kinsfolk_name4':this.kinsfolk_name4,
					'kinsfolk_name5':this.kinsfolk_name5,
					'kinsfolk_name6':this.kinsfolk_name6,
					'kinsfolk_name7':this.kinsfolk_name7,					
					'kinsfolk_age1':this.kinsfolk_age1,
					'kinsfolk_age2':this.kinsfolk_age2,
					'kinsfolk_age3':this.kinsfolk_age3,
					'kinsfolk_age4':this.kinsfolk_age4,
					'kinsfolk_age5':this.kinsfolk_age5,
					'kinsfolk_age6':this.kinsfolk_age6,
					'kinsfolk_age7':this.kinsfolk_age7,					
					'politics_status1':this.politics_status1,
					'politics_status2':this.politics_status2,
					'politics_status3':this.politics_status3,
					'politics_status4':this.politics_status4,
					'politics_status5':this.politics_status5,
					'politics_status6':this.politics_status6,
					'politics_status7':this.politics_status7,					
					'company_name1':this.company_name1,
					'company_name2':this.company_name2,
					'company_name3':this.company_name3,
					'company_name4':this.company_name4,
					'company_name5':this.company_name5,
					'company_name6':this.company_name6,
					'company_name7':this.company_name7,
					'reporting_unit':this.reporting_unit,
					'preparer':this.preparer,					
				};
				this.$axios({
					method: 'post',
					url: 'director/directortwo',
					data: Qs.stringify(data)
				}).then(response => {
//					console.log(response.data);
					let loadingInstance = Loading.service();
					loadingInstance.close();
					if(response.data.state == 3) {
						sessionStorage.setItem('renMian_id',response.data.director_id)
						this.$router.push('/table1');
					} else {
						this.$toast(response.data.msg);
					}
				});
			},
			summit1(){
				if(!this.name) {
					this.$toast('请输入姓名');
					return false;
				};
				if(!this.sex) {
					this.$toast('请选择性别')
					return false;
				};
				if(!this.birthdate) {
					this.$toast('请选择出生日期');
					return false;
				};
				if(!this.people) {
					this.$toast('请输入民族')
					return false;
				};
				if(!this.native_place) {
					this.$toast('请输入籍贯')
					return false;
				};
				if(!this.birthplace) {
					this.$toast('请输入出生地')
					return false;
				};
				if(!this.party_time) {
					this.$toast('请选择入党时间')
					return false;
				};
				if(!this.attack_time) {
					this.$toast('请选择参加工作时间')
					return false;
				};
				if(!this.health_condition) {
					this.$toast('请输入健康状况')
					return false;
				};
				if(!this.professional_title) {
					this.$toast('请输入专业技术职务')
					return false;
				};
				if(!this.speciality) {
					this.$toast('请输入专长')
					return false;
				};
				if(!this.full_time_education && !this.part_time_education) {
					this.$toast('请选填学历')
					return false;
				};
				
				if(this.full_time_education) {
					if(!this.colleges_and_majors1){
						this.$toast('请输入毕业院校及专业')
						return false;
					}					
				};
				
				if(this.part_time_education) {
					if(!this.colleges_and_majors2){
						this.$toast('请输入毕业院校及专业')
						return false;
					}					
				};
				
				if(!this.present_title) {
					this.$toast('请输入现任职务')
					return false;
				};
				if(!this.designated_title) {
					this.$toast('请输入拟任职务')
					return false;
				};
				if(!this.remove_title) {
					this.$toast('请输入拟免职务')
					return false;
				};
				if(!this.curriculum_vitae) {
					this.$toast('请输入简历')
					return false;
				};
				if(!this.rewards_and_penalties) {
					this.$toast('请输入奖惩情况')
					return false;
				};
				if(!this.evaluation_result) {
					this.$toast('请输入年度考核结果')
					return false;
				};
				if(!this.reason) {
					this.$toast('请输入任免理由')
					return false;
				};
				if(!this.kinsfolk_relation1) {
					this.$toast('请输入亲属及关系称谓')
					return false;
				};
				if(!this.kinsfolk_name1) {
					this.$toast('请输入亲属及关系姓名')
					return false;
				};
				if(!this.kinsfolk_age1) {
					this.$toast('请输入亲属及关系年龄')
					return false;
				};
												
				if(!this.politics_status1) {
					this.$toast('请输入亲属及关系政治面貌')
					return false;
				};
				
				if(!this.company_name1) {
					this.$toast('请输入亲属及关系工作单位及职务')
					return false;
				};
				
				if(!this.reporting_unit) {
					this.$toast('请输入呈报单位');
					return false;
				};
				if(!this.preparer) {
					this.$toast('请输入填表人');
					return false;
				};
				Loading.service();							
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data ={
					'access-token':token,
					'id':this.id,
					'director_type':3,
					'name':this.name,
					'sex':this.sex,
					'birthdate':this.old,
					'people':this.people,
					'native_place':this.native_place,
					'birthplace':this.birthplace,
					'party_time':typeof(this.party_time)=='string'?this.party_time:this.party_time.toISOString().slice(0, 10),
					'attack_time':typeof(this.attack_time)=='string'?this.attack_time:this.attack_time.toISOString().slice(0, 10),
					'health_condition':this.health_condition,
					'professional_title':this.professional_title,
					'speciality':this.speciality,
					'full_time_education':this.full_time_education,
					'colleges_and_majors1':this.colleges_and_majors1,
					'part_time_education':this.part_time_education,
					'colleges_and_majors2':this.colleges_and_majors2,
					'present_title':this.present_title,
					'designated_title':this.designated_title,
					'remove_title':this.remove_title,
					'curriculum_vitae':this.curriculum_vitae,
					'rewards_and_penalties':this.rewards_and_penalties,
					'evaluation_result':this.evaluation_result,
					'reason':this.reason,					
					'kinsfolk_relation1':this.kinsfolk_relation1,
					'kinsfolk_relation2':this.kinsfolk_relation2,
					'kinsfolk_relation3':this.kinsfolk_relation3,
					'kinsfolk_relation4':this.kinsfolk_relation4,
					'kinsfolk_relation5':this.kinsfolk_relation5,
					'kinsfolk_relation6':this.kinsfolk_relation6,
					'kinsfolk_relation7':this.kinsfolk_relation7,					
					'kinsfolk_name1':this.kinsfolk_name1,
					'kinsfolk_name2':this.kinsfolk_name2,
					'kinsfolk_name3':this.kinsfolk_name3,
					'kinsfolk_name4':this.kinsfolk_name4,
					'kinsfolk_name5':this.kinsfolk_name5,
					'kinsfolk_name6':this.kinsfolk_name6,
					'kinsfolk_name7':this.kinsfolk_name7,					
					'kinsfolk_age1':this.kinsfolk_age1,
					'kinsfolk_age2':this.kinsfolk_age2,
					'kinsfolk_age3':this.kinsfolk_age3,
					'kinsfolk_age4':this.kinsfolk_age4,
					'kinsfolk_age5':this.kinsfolk_age5,
					'kinsfolk_age6':this.kinsfolk_age6,
					'kinsfolk_age7':this.kinsfolk_age7,					
					'politics_status1':this.politics_status1,
					'politics_status2':this.politics_status2,
					'politics_status3':this.politics_status3,
					'politics_status4':this.politics_status4,
					'politics_status5':this.politics_status5,
					'politics_status6':this.politics_status6,
					'politics_status7':this.politics_status7,					
					'company_name1':this.company_name1,
					'company_name2':this.company_name2,
					'company_name3':this.company_name3,
					'company_name4':this.company_name4,
					'company_name5':this.company_name5,
					'company_name6':this.company_name6,
					'company_name7':this.company_name7,
					'reporting_unit':this.reporting_unit,
					'preparer':this.preparer,					
				};
				this.$axios({
					method: 'post',
					url: 'director/updirectortwo',
					data: Qs.stringify(data)
				}).then(response => {
					console.log(response.data);
					let loadingInstance = Loading.service();
					loadingInstance.close();
					if(response.data.state == 3) {												
						this.$router.push('/table1');
					} else {
						this.$toast(response.data.msg);
					}
				});
			}
		}
	}
</script>
<style scoped>
	textarea{
		border: 1px solid rgba(207, 212, 214, 1);
	}
	.input{
		border: 1px solid rgba(207, 212, 214, 1);
		box-sizing: border-box;
		border-radius: 5px;
		text-indent: 18px;
	}
	.w90{
		width: 90px;
	}
	.h40{
		height: 40px;
	}
	.clearfix::after {
		content: ".";
		clear: both;
		visibility: hidden;
		height: 0;
		display: block;
		line-height: 0;
	}
	
	.clearfix {
		zoom: 1;
	}
	
	.fl {
		float: left;
	}
	
	.fr {
		float: right;
	}
	
	.inline {
		display: inline-block;
	}
	
	.v_middle {
		vertical-align: middle;
	}
	
	.cur {
		cursor: pointer;
	}
	
	.rap {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.flex {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.out {
		height: 40px;
		line-height: 40px;
		color: #808080;
		float: right;
		font-weight: bold;
		cursor: pointer;
	}
	
	.home {
		width: 100%;
		height: auto;
		background: #fff;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #404040;
		text-align: left;
	}
	
	.banner {
		width: 1196px;
		height: 80px;
		position: relative;
		margin: 0 auto;
	}
	
	.logo {
		width: 211px;
		height: 42px;
		position: absolute;
		top: 16px;
		left: 0;
	}
	
	.banner h5 {
		position: absolute;
		top: 26px;
		left: 227px;
		height: 28px;
		font-size: 20px;
		font-weight: bold;
		color: rgba(0, 94, 179, 1);
		line-height: 28px;
	}
	
	.banner h5 span {
		height: 17px;
		color: #E8E8E8;
	}
	
	.user_msg {
		width: 435px;
		padding-top: 22px;
		height: 40px;
		position: absolute;
		top: 0;
		right: 0;
	}
	
	.warn {
		height: 25px;
		line-height: 25px;
		float: left;
		color: #7D7D7D;
		padding-left: 33px;
		background: url(../../static/img/ling.png) no-repeat top left;
		background-size: 24px 25px;
	}
	
	.user_msg img {
		float: left;
		width: 40px;
		height: 35px;
		margin: 0 15px 0 31px;
	}
	
	.user_msg div {
		padding-right: 20px;
		text-align: left;
		float: left;
		width: 168px;
		height: 100%;
	}
	
	.user_msg div p {
		font-size: 12px;
		color: #BFBFBF;
	}
	
	.center {
		width: 100%;
		height: auto;
		background: #F6F8F9;
		padding-bottom: 32px;
		padding-top: 40px;
	}
	.shade{
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,.7);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 99;
	}
	.tc{
		width: 384px;
		height: 185px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		background:rgba(255,255,255,1);
		box-shadow:0px 4px 12px 0px rgba(0,0,0,0.15);
		border-radius:4px;
		padding: 16px 24px;
		box-sizing: border-box;
		text-align: center;
	}
	.tc_tit{
		position: relative;
		font-size: 16px;
		font-weight: bold;
		text-align: left;
		height: 20px;
		line-height: 20px;
		margin-bottom: 20px;
	}
	.closed{
		width:14px;
		height: 14px;
		background: url(../../static/img/close.png) no-repeat;
		background-size:100%;
		position: absolute;
		right: 0;
		top: 3px;
	}
	.tc div{
		position: absolute;
		bottom: 35px;
		left: 0;
		width: 100%;
		margin: 0 auto;
		box-sizing: border-box;
		padding: 0 80px;
		height: 24px;
	}
	.tc div span{
		cursor: pointer;
		line-height: 22px;
		color: #fff;
		float: left;
		width:72px;
		height:24px;
		background:rgba(24,144,255,1);
		border-radius:4px;
	}
	.tc .sure{
		float: right;
	}
	.con_con {
		margin: 0 auto;
		padding: 22px 36px 22px 26px;
		width: 952px;
		height: auto;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(207, 212, 214, 1);
		box-sizing: border-box;
	}
	
	.con_con_top {
		position: relative;
		text-align: center;
		height: 57px;
		line-height: 57px;
		font-size: 16px;
		font-weight: bold;
		border-bottom: 1px solid rgba(207, 212, 214, 1);
	}
	
	.con_con_top a {
		position: absolute;
		right: 0;
		bottom: 0;
		height: 30px;
		line-height: 30px;
		color: #0076FF;
		font-size: 14px;
	}
	
	.con_con_form {
		width: 100%;
		height: auto;
		color: #4F4F4F;
		font-weight: bold;
	}
	
	.con_con_form_tit {
		line-height: 58px;
		font-weight: bold;
		text-indent: 28px;
	}
	
	.con_con_item {
		width: 100%;
		height: 40px;
		margin-bottom: 30px;
	}
	
	.con_con_item input[type="text"] {
		height: 40px;
		border: none;
		border: 1px solid rgba(207, 212, 214, 1);
		box-sizing: border-box;
		border-radius: 5px;
		text-indent: 18px;
	}
	
	.con_con_item span {
		display: inline-block;
		text-align: center;
	}
	
	.con_con_item .type1 {
		width: 85px;
		line-height: 40px;
		text-align: right;
		margin-right: 10px;
	}
	
	.con_con_form_center {
		border-top: 1px solid rgba(0, 0, 0, 0);
		width: 100%;
		height: auto;
		overflow: hidden;
		box-sizing: border-box;
		margin-bottom: 20px;
	}
	
	.con_con_form_center p {
		float: left;
		width: 14px;
		height: 100px;
		font-weight: bold;
		color: rgba(79, 79, 79, 1);
		line-height: 20px;
		margin: 122px 0 0 40px;
	}
	
	.con_con_table {
		float: right;
		width: 788px;
		height: auto;
		overflow: hidden;	
	}
	
	.con_con_table ul {
		width: 100%;
		height: 56px;
		background: rgba(251, 251, 251, 1);
	}
	
	.con_con_table ul li {
		float: left;
		width: 33%;
		line-height: 56px;
		text-align: center;
	}
	
	.con_con_table_body {
		padding: 15px 0 0 25px;
	}
	
	.con_con_table_body input {
		width: 208px;
	}
	
	.con_con_item1 {
		width: 100%;
		height: 150px;
		margin-bottom: 20px;
	}
	
	.con_con_item1 p {
		text-align: center;
		width: 40px;
		height: 150px;
		font-weight: bold;
		color: rgba(79, 79, 79, 1);
		margin-left: 40px;
	}
	
	.con_con_item1 div {
		border: 1px solid rgba(207, 212, 214, 1);
		width: 786px;
		height: 100%;
		box-sizing: border-box;
	}
	
	.btn {
		display: block;
		border: none;
		width: 160px;
		height: 48px;
		background: rgba(0, 118, 255, 1);
		border-radius: 4px;
		color: #fff;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/components/Appoint.vue